"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'pricing',
  data: function data() {
    return {
      type: this.$route.query.type || '1',
      id: this.$route.params.id || '',
      card: {},
      form: {},
      form_key: {
        free_invest_device: 0,
        kc_cdb_buy_price: '',
        mc_cdb_buy_price: '',
        kc_lymmx_buy_price: '',
        mc_lymmx_buy_price: '',
        kc_mmx_buy_price: '',
        mc_mmx_buy_price: ''
      }
    };
  },
  computed: {},
  mounted: function mounted() {
    this.getMemberCard();
    this.getInfo();
  },
  methods: {
    /**
     * 获取信息
     */
    getInfo: function getInfo() {
      var _this = this;
      this.$get('agentapi/my_merchant_detail', {
        store_id: this.id
      }).then(function (res) {
        var params = {};
        for (var i in _this.form_key) {
          params[i] = res.buy_price[i];
        }
        _this.form = params;
      });
    },
    /**
     * 修改商户的部分
     */
    editShopPart: function editShopPart(row) {
      var _this2 = this;
      var params = {
        store_id: this.id,
        type: this.type
      };
      params.free_invest_device = this.form.free_invest_device;
      params.kc_cdb_buy_price = this.form.kc_cdb_buy_price;
      params.mc_cdb_buy_price = this.form.mc_cdb_buy_price;
      params.mc_mmx_buy_price = this.form.mc_mmx_buy_price;
      params.kc_mmx_buy_price = this.form.kc_mmx_buy_price;
      params.mc_lymmx_buy_price = this.form.mc_lymmx_buy_price;
      params.kc_lymmx_buy_price = this.form.kc_lymmx_buy_price;
      this.$post('agentapi/store/type_switch', params).then(function (res) {
        _this2.$message({
          type: 'success',
          message: '设置成功'
        });
      });
    },
    /**
     * 会员卡信息
     */
    getMemberCard: function getMemberCard() {
      var _this3 = this;
      var card = {};
      this.$get('agentapi/store/member_card', {
        store_id: this.id
      }).then(function (res) {
        card = res.store_memebr_card_info.std_zhuang;
        card.member_card_switch = res.member_card_switch;
        _this3.card = card;
      });
    },
    /**
     * 提交会员卡信息
     */
    postCard: function postCard() {
      var _this4 = this;
      var params = this.card;
      params.store_id = this.id;
      params.type = params.depend_type;
      this.$post('agentapi/store/member_card', params).then(function (res) {
        _this4.$message({
          message: '提交成功',
          type: 'success'
        });
      });
    }
  }
};